import React from "react";
import Link from "gatsby-link"


export default () => (

  <div style={{
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '8vh',
    alignItems:'center'
  }}>

  <ul className="navigation">
    <li><Link style={{textDecoration:"none"}} to="/#menu"><div className="navigation__item">Menü</div></Link></li>
    <li><Link style={{textDecoration:"none"}} to="/contact"><div className="navigation__item">Reservieren</div></Link></li>
    <li><Link style={{textDecoration:"none"}} to="/#anfahrt"><div className="navigation__item">Anfahrt</div></Link></li>
    <li><Link style={{textDecoration:"none"}} to="/impressung"><div className="navigation__item">Impressung</div></Link></li>
  </ul>
</div>
)





// WEBPACK FOOTER //
// ./src/components/navigation.js